import { getListFromEdgesList } from '../../components'
import { GetVendorCategories, CategoryWithChildren } from '../../services'

export const reduceVendorsCategories = (
  data: GetVendorCategories
): CategoryWithChildren[] => getListFromEdgesList(data.categories)
